module.exports = __webpack_public_path__ + "img/under-pic.691a7bcf.png";